import { render, staticRenderFns } from "./HAS1060.vue?vue&type=template&id=01fa37f5&scoped=true&"
import script from "./HAS1060.vue?vue&type=script&lang=js&"
export * from "./HAS1060.vue?vue&type=script&lang=js&"
import style0 from "./HAS1060.vue?vue&type=style&index=0&id=01fa37f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fa37f5",
  null
  
)

export default component.exports